import mockAxios, { AxiosResponse } from 'axios';
import { IHrDepartmentServiceMock } from './hr-department.mock.types';

export const mockHrDepartmentService = (): IHrDepartmentServiceMock => ({
  fetchHrDepartments: jest.fn(),
  fetchHrDepartment: jest.fn(),
  createHrDepartment: jest.fn(),
  updateHrDepartment: jest.fn(),
  deleteHrDepartment: jest.fn()
});

export const mockHrDepartmentAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
